'use client';

import { Button } from '@ahafood/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@ahafood/ui/components/dialog';
import { Image } from '@ahafood/ui/components/image';
import { assetPrefix } from '@ahm/api-wrappers-core';
import { X } from 'lucide-react';

interface RatingSuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RatingSuccessDialog({
  open,
  onOpenChange,
}: RatingSuccessDialogProps) {
  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-xs md:max-w-md mx-auto rounded-3xl border-none p-0">
        <DialogHeader className="sr-only">
          <DialogTitle>Cảm ơn đánh giá</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center text-center p-6 space-y-6">
          {/* Close button */}
          <Button
            size="icon"
            onClick={handleClose}
            variant="ghost"
            className="absolute top-3 bg-white right-3 rounded-full size-10 [&_svg]:size-4 shadow-4 z-[99]"
          >
            <X />
          </Button>
          <div className="relative size-48">
            <Image
              src={`${assetPrefix}/static/images/rating-sucess.webp`}
              alt="Success robot mascot"
              fill
              className="object-contain"
            />
          </div>
          <h2 className="text-xl font-bold text-neutral-90">
            Cảm ơn đánh giá của bạn!
          </h2>
          {/* Description */}
          <p className="text-neutral-60 text-sm max-w-sm">
            Bạn có thể cập nhật đánh giá trong vòng 7 ngày kể từ khi đơn hoàn
            thành. Đánh giá của bạn giúp cửa hàng nâng cao chất lượng dịch vụ ❤️
          </p>
          {/* Button */}
          <Button
            variant="default"
            onClick={handleClose}
            className="w-full rounded-lg font-medium"
          >
            Đã hiểu
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
